module.exports = __webpack_public_path__ + "img/tip_fpe_6.d5eced4f.png";